import React, { PropsWithChildren } from "react";

import "./contentBlock.scss";

type ContentBlockLinkProps = PropsWithChildren<{
    className?: string;
    url?: string;
}>;

export const ContentBlockLink = ({
    className,
    url,
    children,
}: ContentBlockLinkProps) => (
    <article>
        <a href={url} rel={"bookmark"} className={className}>
            {children}
        </a>
    </article>
);
